import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import Thread from 'Components/threads/ThreadComponent';
import forumViewSelector from 'Selectors/forumViewSelector';

import AdComponent from 'Components/ads/AdComponent';

import { pathToThread } from 'Utils/nav/NavHelpers';
import { resetForum } from 'Actions/ForumviewActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { getPageSize } from 'Actions/UserSettingsActions';

class ThreadListComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.pages = {};
	}

	shouldComponentUpdate( nextProps ) {
		return (
			!isEqual( nextProps.meta.selectedElements, this.props.meta.selectedElements ) ||
			!isEqual( nextProps.forumview, this.props.forumview ) ||
			!isEqual( nextProps.pages, this.props.pages )
		);
	}

	gotoThread = ( id ) => {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( push( pathToThread(id) ) );
	};

	buildTopic = ( topic, i, pageNum, pageSize ) => {
		const { entities } = this.props.forumview,
			isSearch = this.props.isSearch;

		let adUnit = '';
		if( isSearch ) {
			let searchProp = {
				isTop: false,
				page: ( ( this.props.forumview.page - 1 ) * ( pageSize / 10 ) ) + ( ( i + 1 ) / 10 ),
				searchQuery: this.props.forumview.query.searchQuery
			};
			adUnit = ( ( i + 1 ) % 10 === 0 ) ? <AdComponent key={ `In_Search_Ad_${ topic.id }` } adType="0" adName={ 'In_Search_Ad_' + topic.id } search={ searchProp } tag="li" /> : null;
		} else {
			adUnit = ( i % 4 === 0 && i !== 0 ) ? <AdComponent key={ `In_Content_Ad_${ topic.id }` } adType="1" adName={ 'In_Content_Ad_' + topic.id } tag="li" /> : null;
		}

		let thisUser = this.props.showLast && topic.lastUserid && entities.users[ topic.lastUserid ] ? entities.users[ topic.lastUserid ] : entities.users[ topic.forumUser ];

		let the_topic = [
			<li key={ topic.id } onClick={ () => this.gotoThread( topic.id ) }>
				<Thread
					thread={ topic }
					isSubscribable={ true }
					isSearch={ isSearch }
					user={ thisUser }
					dispatch={ this.props.dispatch }
					ustate={ this.props.ustate }
					showLast={ this.props.showLast }
					selectedElements={ this.props.meta.selectedElements }
				/>
			</li>
		];

		if( adUnit ) {
			the_topic.push( adUnit );
		}

		return the_topic;
	};

	buildPage = ( pageNum, pageSize ) => {
		const { entities, result } = this.props.forumview;

		let topics = result.topics.filter( e => entities.topics[ e ] && entities.topics[ e ].page === pageNum ),
			topicsList = topics.map( ( id, i ) => this.buildTopic( entities.topics[ id ], i, pageNum, pageSize ) );

		return (
			<ul key={pageNum} className={`scroll_page page_${pageNum}`}>
				{ topicsList }
			</ul>
		)
	};

	threadListPage () {
		const pageSize = this.props.dispatch( getPageSize() );
		return this.props.pages.map( ( pageNum ) => this.buildPage( pageNum, pageSize ) );
	}

	summary(){
		const {entities: {forums}, forumId, total} = this.props.forumview;
		if ( forums && forums.hasOwnProperty(forumId) ) {
			return <div className="summary">{ total.toLocaleString() } Topics</div>
		}
		return ''
	}

	render() {
		const { result } = this.props.forumview;

		if (result.topics.length === 0) {
			return <span />
		}

		return (
			<div ref={ this.props.listRef } className="threads">
				{ this.summary() }
				{ this.threadListPage() }
			</div>
		);
	}
}

ThreadListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	pages: PropTypes.array.isRequired,
};

export default connect( forumViewSelector )( ThreadListComponent );



// WEBPACK FOOTER //
// ./src/components/threads/ThreadListComponent.js